import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import S from './ResultVerificationSection.styles';

const ResultVerificationPagination = ({
  currentQuestion = 0,
  totalQuestion = 1,
  onPrevPage,
  onNextPage
}) => {
  const [currentPage, setCurrentPage] = useState(currentQuestion + 1);
  const [totalPage, setTotalPage] = useState(totalQuestion);
    
  useEffect(() => {
    const page = currentQuestion + 1;
    setCurrentPage(page);
    setTotalPage(totalQuestion);
  }, [currentQuestion, totalQuestion]);
  
  const prevPage = e => {
    e.preventDefault();
    const page = currentPage - 1;
    if (page > 0) {
      setCurrentPage(page);
      onPrevPage(page);
    }
  };
  const nextPage = e => {
    e.preventDefault();
    const page = currentPage + 1;
    if (page <= totalPage) {
      setCurrentPage(page);
      onNextPage(page);
    }
  };

  return (
    <S.PageNavigation>
    <S.Arrow
      left
      onClick={e => prevPage(e)}
      disabled={ currentPage === 1 }
    >
      <S.IconL id="left-icon" name="arrowLeft" />
      </S.Arrow>
      <S.PaginationText>{currentPage}/{totalPage}</S.PaginationText>
      <S.Arrow
        right
        onClick={e => nextPage(e)}
        disabled={currentPage >= totalPage}
      >
      <S.IconR name="arrowRight" />
    </S.Arrow>
  </S.PageNavigation>);
};

export default ResultVerificationPagination;

ResultVerificationPagination.propTypes = {
  currentQuestion: PropTypes.number,
  totalQuestion: PropTypes.number,
  onPrevPage: PropTypes.func,
  onNextPage: PropTypes.func,
};
